import { useClickAway } from '@uidotdev/usehooks';
import React, { useState, useMemo, useEffect } from 'react';
import { IoSearchOutline } from 'react-icons/io5';
import { MdClose } from 'react-icons/md';
import Modal from 'react-responsive-modal';
import { fileExtension, getONLYUSERSDATA, getThumImage, niceBytes } from '../../../../Utils/Common';
// import moment from 'moment';
import addFileAttachment from "../../../../media/icons/assets_light/outline-action-attach-active.svg";
import ClearIcon from '../../../../media/icons/assets_light/outline-action-close-active.svg';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveFile, setPopup } from '../../../../redux/messageSlice';
import { set_active_task } from '../../../../redux/taskSlice';


const FilesSection = () => {
  const dispatch = useDispatch();
  const { active_task, change_file_data } = useSelector(state => state.task);
  const { allUsers } = useSelector(state => state.message)
  // const [files, setFiles] = useState(active_task?.files || []);

  const [searchFileName, setSearchFileName] = useState('');
  const [filterFileOptions, setFilterFileOptions] = useState(false);
  const [selectedItemIndex, setSelectedItemIndex] = useState(-1);
  const [selectedTagsIndex, setSelectedTagsIndex] = useState(-1);
  const [selectedFilters, setSelectedFilters] = useState("date_- Descending");
  const availableFilters = ['title_- Ascending', 'title_- Descending', 'date_- Ascending', 'date_- Descending', 'size', 'type', 'uploaded_by', 'reference_ID', 'starred_files'];

  // Filter and sort files based on search and selected filters
  // const filteredFiles = useMemo(() => {
  //   let result = [...(active_task?.files || [])];

  //   // Apply search filter
  //   if (searchFileName) {
  //     result = result.filter(file =>
  //       file.originalname?.toLowerCase().includes(searchFileName.toLowerCase())
  //     );
  //   }

  //   // Apply sorting/filtering
  //   switch (selectedFilters) {
  //     case 'title_- Ascending':
  //       result.sort((a, b) => (a.originalname || '').localeCompare(b.originalname || ''));
  //       break;
  //     case 'title_- Descending':
  //       result.sort((a, b) => (b.originalname || '').localeCompare(a.originalname || ''));
  //       break;
  //     case 'date_- Ascending':
  //       result.sort((a, b) => new Date(a.created_at || 0) - new Date(b.created_at || 0));
  //       break;
  //     case 'date_- Descending':
  //       result.sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0));
  //       break;
  //     case 'size':
  //       result.sort((a, b) => {
  //         const sizeA = parseFloat(a.file_size) || 0;
  //         const sizeB = parseFloat(b.file_size) || 0;
  //         return sizeA - sizeB;
  //       });
  //       break;
  //     case 'type':
  //       result.sort((a, b) => {
  //         const extA = (a.file_type || '').split('/').pop() || '';
  //         const extB = (b.file_type || '').split('/').pop() || '';
  //         return extA.localeCompare(extB);
  //       });
  //       break;
  //     case 'uploaded_by':
  //       result.sort((a, b) => {
  //         const userA = getONLYUSERSDATA(allUsers, a.user_id, 'name') || '';
  //         const userB = getONLYUSERSDATA(allUsers, b.user_id, 'name') || '';
  //         return userA.localeCompare(userB);
  //       });
  //       break;
  //     case 'reference_ID':
  //       result.sort((a, b) => {
  //         const refA = a.referenceId || '';
  //         const refB = b.referenceId || '';
  //         return refA.localeCompare(refB);
  //       });
  //       break;
  //     case 'starred_files':
  //       // Show starred files first
  //       result.sort((a, b) => {
  //         const hasStarA = a.star && a.star.length > 0;
  //         const hasStarB = b.star && b.star.length > 0;
  //         if (hasStarA && !hasStarB) return -1;
  //         if (!hasStarA && hasStarB) return 1;
  //         return 0;
  //       });
  //       break;
  //     default:
  //       // Default sorting by date descending
  //       result.sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0));
  //   }

  //   return result;
  // }, [searchFileName, selectedFilters, allUsers, active_task?.files]);

  useEffect(() => {
    if (!change_file_data) return;

    if (change_file_data.xmpp_type === "star_file") {
      dispatch(
        set_active_task({
          ...active_task,
          files: active_task.files.map((f) =>
            f.id === change_file_data.file_id
              ? { ...f, star: change_file_data.star }
              : f
          ),
        })
      );
    }

    else if (
      change_file_data.xmpp_type === "delete_msg" ||
      change_file_data.xmpp_type === "delete_one_file"
    ) {
      dispatch(
        set_active_task({
          ...active_task,
          files: active_task.files.filter(
            (f) => f.id !== change_file_data.file_id
          ),
        })
      );
    }

    else if (change_file_data.xmpp_type === "add_remove_tag_into_msg") {
      dispatch(
        set_active_task({
          ...active_task,
          files: active_task.files.map((f) =>
            f.id === change_file_data.file_id ||
              change_file_data.file_id === change_file_data.conversation_id
              ? {
                ...f,
                tag_list: f.tag_list
                  ? [
                    ...f.tag_list.filter(
                      (t) => !change_file_data.removetag.includes(t)
                    ),
                    ...change_file_data.newtag.filter(
                      (t) => !f.tag_list.includes(t)
                    ),
                  ]
                  : [...change_file_data.newtag],

                tag_list_details:
                  f.tag_list_details && f.tag_list
                    ? [
                      ...f.tag_list_details.filter(
                        (t) =>
                          !change_file_data.removetag.includes(t.tag_id)
                      ),
                      ...change_file_data.newtag_tag_data.filter(
                        (t) => !f.tag_list.includes(t.tag_id)
                      ),
                    ]
                    : [...change_file_data.newtag_tag_data],
              }
              : f
          ),
        })
      );
    }

    else if (change_file_data.xmpp_type === "file_share_link_create") {
      dispatch(
        set_active_task({
          ...active_task,
          files: active_task.files.map((f) =>
            f.id === change_file_data.id
              ? { ...f, url_short_id: change_file_data.url_short_id }
              : f
          ),
        })
      );
    }

  }, [change_file_data]);

  const hideHoverTagsHandler = () => {
    setSelectedTagsIndex(-1);
  };

  const ref = useClickAway(() => {
    setFilterFileOptions(false);
  });

  const handleFilterClick = (filter) => {
    setSelectedFilters(filter);
    setFilterFileOptions(false);

  };
  useEffect(() => {
    // setLoading(true);
    const timeout = setTimeout(() => {
      // setLoading(false);
      dispatch(setPopup({ key: 'chat_loader', value: false }))
    }, 1000); // simulate API delay

    return () => clearTimeout(timeout);
  }, []);

  const viewFile = (e, file) => {
    if (e.target.id === "playIcon") return;
    dispatch(setActiveFile(file))
    dispatch(setPopup({ key: 'file_drawer', value: true }))
  }

  // return (
  //   <div className="bg-white py-6 flex flex-col max-h-[455px] min-h-[200px] dark:bg-surface-dark">

  //     {active_task?.files?.length > 0 ?
  //       <div className='mostRecentTagsFlexBox !rounded-b-2xl'>
  //         {active_task?.files?.length > 0 &&
  //           <div className='flex items-center justify-between relative mb-[10px]'>
  //             <div className='flex items-center justify-start'>

  //               <div
  //                 className="filterIconsGray !bg-[length:20px] !w-[20px] cursor-pointer -ml-1.5"
  //                 onClick={() => setFilterFileOptions(!filterFileOptions)}
  //               >

  //               </div>
  //               {selectedFilters && (
  //                 <div className="selected-filter max-w-max  !left-[10px]">
  //                   <div className="filtered_item_name w-max text-[10px] bg-teal-600 text-white rounded-full px-3 py-0.5">
  //                     <span> {selectedFilters.charAt(0).toUpperCase() + selectedFilters.slice(1).replace('_', ' ')}</span>
  //                   </div>
  //                 </div>
  //               )}
  //             </div>
  //             <div className="relative w-44">
  //               <input
  //                 onChange={(e) => setSearchFileName(e.target.value)}
  //                 value={searchFileName}
  //                 type="text"
  //                 className="searchInputbox h-[30px] w-full text-xs px-2.5 focus:border-border-action rounded-full border border-border-primary dark:!bg-surface-dark !placeholder-[#318fff]"
  //                 placeholder="Search file name"
  //                 autoFocus={true}
  //               />
  //               {searchFileName.length > 0 ? (
  //                 <div
  //                   id="clearNot"
  //                   onClick={() => setSearchFileName('')}
  //                   className={`absolute top-[7px] right-[10px] bg-[#636E82] hover:!bg-[#318FFF] dark:!bg-white w-[16px] h-[16px] cursor-pointer transition-all duration-300`}
  //                   style={{
  //                     WebkitMaskImage: `url(${ClearIcon})`,
  //                     WebkitMaskRepeat: "no-repeat",
  //                     WebkitMaskPosition: "center",
  //                     WebkitMaskSize: "contain",
  //                     maskImage: `url(${ClearIcon})`,
  //                     maskRepeat: "no-repeat",
  //                     maskPosition: "center",
  //                     maskSize: "contain",
  //                   }}
  //                 />
  //               ) : (
  //                 <IoSearchOutline size="16px" className="absolute right-3 top-2 text-2xl text-[#0b1f47]" />
  //               )}
  //             </div>
  //             {filterFileOptions && (
  //               <div ref={ref} className="bg-white w-52 z-10 rounded-lg border border-[#e3f2ff] absolute top-10 left-8 tagsFilterOptions">
  //                 {availableFilters.map((option) => (
  //                   <p
  //                     key={option}
  //                     onClick={() => handleFilterClick(option)}
  //                     className={`text-[12px] py-1.5 px-4 hover:bg-[#D9D9D9] cursor-pointer ${selectedFilters === option ? 'bg-blue-100 text-blue-800' : 'text-[#0b1f47]'
  //                       }`}
  //                   >
  //                     {option.charAt(0).toUpperCase() + option.slice(1).replace('_', ' ')}
  //                   </p>
  //                 ))}
  //               </div>
  //             )}
  //           </div>
  //         }

  //         <div className='!rounded-b-2xl'>
  //           {active_task?.files?.length > 0 &&
  //             <div className="mostRecentTagshead rounded flex gap-3 py-3 items-center border-b border-b-border-primary relative">
  //               <p className="text-text-body dark:!text-white text-[12px] w-[40%] ">File name</p>
  //               <p className="text-text-body dark:!text-white text-[12px] w-[30%]">Uploaded by</p>
  //               <p className="text-text-body dark:!text-white text-[12px] w-[30%] flex ">Tags</p>
  //             </div>
  //           }

  //           <div className="h-[218px] overflow-y-auto relative fileListBlock">
  //             {filteredFiles.length > 0 ? (
  //               filteredFiles.map((file, index) => {
  //                 const showFullTagsPopup = selectedItemIndex === index;
  //                 const showCompactTagsPopup = selectedTagsIndex === index && !showFullTagsPopup;

  //                 return (
  //                   <div key={file.id} className="relative border-b border-b-border-primary last:border-b-0">
  //                     {/* File Row */}
  //                     <div
  //                       className="filteredFilesArea group cursor-pointer flex gap-3 py-[10px] items-center hover:bg-[#D9D9D9] border-b border-b-[#e3f2ff] last:border-b-0"

  //                     >
  //                       {/* File content */}
  //                       <div onClick={(e) => viewFile(e, file)} className="w-[40%] flex gap-2 items-center">
  //                         {/* <MdInsertDriveFile className="text-[#0b1f47]" size={24}/> */}
  //                         <div className="img_holderr cursor-pointer !w-[25px] !h-[25px]">
  //                           {file.location.includes('blob:') ?
  //                             <img src={file.location} loading='lazy' alt="img" />
  //                             :
  //                             <img src={
  //                               file.file_type?.indexOf('image') > -1 && file.file_type?.indexOf('svg') === -1 ?
  //                                 getThumImage(file.location)
  //                                 : file.file_category?.indexOf('voice') > -1 ?
  //                                   `/images/light_theme/voice.svg`
  //                                   : `/images/light_theme/${fileExtension(file?.originalname)}.svg`
  //                             }
  //                               loading='lazy' alt="file ext" title="sender" className="file_ext" />
  //                           }
  //                         </div>
  //                         <div>
  //                           <p className="text-[#0b1f47] text-[12px] truncate w-[90px]">{file.originalname}</p>

  //                           <p className="text-text-body text-[12px] dark:!text-white font-semibold flex space-x-2">
  //                             <span>{niceBytes(file.file_size)}</span>
  //                           </p>
  //                         </div>
  //                       </div>

  //                       <div onClick={(e) => viewFile(e, file)} className="w-[30%] text-[#0b1f47] text-[12px]">
  //                         <p>{getONLYUSERSDATA(allUsers, file.user_id, 'name')}</p>
  //                       </div>

  //                       <div
  //                         className="w-[30%] flex justify-start relative"
  //                         onClick={(e) => e.stopPropagation()}
  //                       >
  //                         {file.tag_list_details?.length > 1 ? (
  //                           <div
  //                             className="colorGroup flex gap-1 cursor-pointer items-center"
  //                             onClick={(e) => {
  //                               e.stopPropagation();
  //                               setSelectedItemIndex(selectedItemIndex === index ? -1 : index);
  //                             }}
  //                           >
  //                             {file.tag_list_details.slice(0, 1).map((tag, i) => (
  //                               <div key={i} className='font-poppins text-[10px] font-normal tracking-normal text-left text-white py-0.5 px-2 rounded-[25px]' style={{ backgroundColor: tag.tag_color }}>{tag.title}</div>
  //                             ))}

  //                             <span className="h-[19px] text-[12px] flex-none flex flex-row justify-center items-center gap-[10px]  rounded-full bg-[#2772cc] text-[#fff] py-0.5 px-2">
  //                               +{file.tag_list_details.length - 1}
  //                             </span>
  //                           </div>
  //                         ) : (
  //                           <div
  //                             className="colorGroup flex gap-1"
  //                             onMouseEnter={() => {
  //                               if (file.tag_list_details?.length <= 2) {
  //                                 setSelectedTagsIndex(index);
  //                               }
  //                             }}
  //                             onMouseLeave={() => {
  //                               if (!showFullTagsPopup) {
  //                                 hideHoverTagsHandler();
  //                               }
  //                             }}
  //                           >
  //                             {file.tag_list_details?.map((tag, i) => (
  //                               <div key={i} className='font-poppins text-[10px] font-normal tracking-normal text-left text-white py-0.5 px-2 rounded-[25px]' style={{ backgroundColor: tag.tag_color }}>{tag.title}</div>
  //                             ))}
  //                           </div>
  //                         )}

  //                         {/* Compact Tags Popup (shown on hover) */}
  //                         {showCompactTagsPopup && (
  //                           <div
  //                             className="absolute top-full right-0 mt-1 bg-white rounded shadow-lg p-3 z-30 border border-gray-200 w-48"
  //                             onMouseEnter={() => setSelectedTagsIndex(index)}
  //                             onMouseLeave={hideHoverTagsHandler}
  //                           >
  //                             <h2 className="text-[12px] font-medium mb-2">File tags</h2>
  //                             <div className="flex flex-wrap gap-1">
  //                               {file.tag_list_details?.map((tag) => (
  //                                 <span
  //                                   key={tag.tag_id}
  //                                   style={{ background: tag.tag_color }}
  //                                   className="px-2 py-0.5 rounded-full text-white text-xs"
  //                                 >
  //                                   {tag.title}
  //                                 </span>
  //                               ))}
  //                             </div>
  //                           </div>
  //                         )}
  //                         {/* Full Tags Popup Modal */}
  //                         <Modal
  //                           open={showFullTagsPopup}
  //                           onClose={() => setSelectedItemIndex(-1)}
  //                           center
  //                           closeIcon={<MdClose className="text-3xl mt-1 text-teal-600 dark:text-white" />}
  //                           focusTrapped={false}
  //                           classNames={{
  //                             overlay: 'customOverlay',
  //                             modal: 'customModal',
  //                           }}
  //                         >
  //                           <div>
  //                             <h2 className="text-xl font-semibold text-teal-600 mb-3">
  //                               File tags
  //                             </h2>
  //                             <div className="flex flex-wrap gap-2 max-h-40 overflow-y-auto">
  //                               {file.tag_list_details?.length > 0 ? (
  //                                 file.tag_list_details?.map((tag) => (
  //                                   <span
  //                                     key={tag.tag_id}
  //                                     style={{ backgroundColor: tag.tag_color }}
  //                                     className="text-white text-xs px-3 py-1 rounded"
  //                                   >
  //                                     {tag.title}
  //                                   </span>
  //                                 ))
  //                               ) : (
  //                                 <p className="text-sm text-gray-500">No tags available</p>
  //                               )}
  //                             </div>
  //                           </div>
  //                         </Modal>
  //                       </div>
  //                     </div>
  //                   </div>
  //                 );
  //               })
  //             ) : (
  //               <div className="p-4 w-full h-full flex items-center justify-center text-center text-[#0b1f47]">
  //                 <div className='flex justify-center items-center flex-wrap'>
  //                   <p>No files found for this search.</p>
  //                   {active_task?.files?.length === 0 && (
  //                     <label onClick={() => dispatch(setPopup({ key: 'upload_popup', value: true }))} className="addFileAttachment group cursor-pointer  flex items-center gap-1 mt-3">
  //                       <div className="text-left text-[14px] text-[#0b1f47] dark:text-white group-hover:text-text-action">
  //                         Add file(s)
  //                       </div>

  //                       <div className="w-[20px] h-[20px] bg-[#636E82] group-hover:!bg-[#318FFF] transition-colors"
  //                         style={{
  //                           WebkitMaskImage: `url(${addFileAttachment})`,
  //                           WebkitMaskRepeat: "no-repeat",
  //                           WebkitMaskPosition: "center",
  //                           WebkitMaskSize: "contain",
  //                           maskImage: `url(${addFileAttachment})`,
  //                           maskRepeat: "no-repeat",
  //                           maskPosition: "center",
  //                           maskSize: "contain",
  //                         }}
  //                       />
  //                     </label>
  //                   )}
  //                 </div>
  //               </div>
  //             )}
  //           </div>

  //           <div className="addFileAttachment group cursor-pointer py-2 flex items-center gap-1">
  //             {active_task?.files?.length > 0 &&
  //               <label onClick={() => dispatch(setPopup({ key: 'upload_popup', value: true }))} className="addFileAttachment group cursor-pointer  flex items-center gap-1">
  //                 <div className="text-left text-[12px] text-[#0b1f47] dark:text-white group-hover:text-text-action">
  //                   Add file(s)
  //                 </div>

  //                 <div className="w-[20px] h-[20px] bg-[#636E82] group-hover:!bg-[#318FFF] transition-colors"
  //                   style={{
  //                     WebkitMaskImage: `url(${addFileAttachment})`,
  //                     WebkitMaskRepeat: "no-repeat",
  //                     WebkitMaskPosition: "center",
  //                     WebkitMaskSize: "contain",
  //                     maskImage: `url(${addFileAttachment})`,
  //                     maskRepeat: "no-repeat",
  //                     maskPosition: "center",
  //                     maskSize: "contain",
  //                   }}
  //                 />
  //               </label>
  //             }
  //           </div>
  //         </div>
  //       </div>
  //       :
  //       <div className="p-6 text-center" onClick={() => dispatch(setPopup({ key: 'upload_popup', value: true }))}>
  //         <div className="w-14 h-14 bg-violet-50 rounded-2xl flex items-center justify-center mx-auto mb-3">
  //           <svg className="w-7 h-7 text-violet-400" fill="none" viewBox="0 0 24 24">
  //             <path d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  //           </svg>
  //         </div>
  //         <p className="text-sm font-semibold text-slate-700 mb-1">No files uploaded yet</p>
  //         <p className="text-xs text-slate-400">Click to select files to upload</p>
  //       </div>
  //     }
  //   </div>
  // );

  const SORT_OPTIONS = [
    { key: "date_- Descending", label: "Newest first" },
    { key: "date_- Ascending", label: "Oldest first" },
    { key: "title_- Ascending", label: "Name A→Z" },
    { key: "title_- Descending", label: "Name Z→A" },
    { key: "size", label: "By size" },
    { key: "type", label: "By type" },
    { key: "starred_files", label: "Starred first" },
  ];


  // const fmt = b => { const n = parseInt(b); return n < 1024 ? `${n}B` : n < 1048576 ? `${(n / 1024).toFixed(1)}KB` : `${(n / 1048576).toFixed(1)}MB`; };

  const [files, setFiles] = useState(active_task?.files || []);
  const [search, setSearch] = useState("");
  const [sortKey, setSortKey] = useState("date_- Descending");
  const [showSortMenu, setShowSortMenu] = useState(false);
  const [viewMode, setViewMode] = useState("grid"); // "list" | "grid"

  // Sync if parent updates files
  useState(() => { setFiles(active_task?.files || []); }, [active_task?.files]);

  const toggleStar = (id) => {
    // setFiles(prev => prev.map(f =>
    //   f.id === id
    //     ? { ...f, star: f.star?.length ? [] : ["me"] }
    //     : f
    // ));
  };

  const filteredFiles = (() => {
    let result = [...files];
    if (search) result = result.filter(f => f.originalname?.toLowerCase().includes(search.toLowerCase()));
    switch (sortKey) {
      case "title_- Ascending": result.sort((a, b) => (a.originalname || "").localeCompare(b.originalname || "")); break;
      case "title_- Descending": result.sort((a, b) => (b.originalname || "").localeCompare(a.originalname || "")); break;
      case "date_- Ascending": result.sort((a, b) => new Date(a.created_at || 0) - new Date(b.created_at || 0)); break;
      case "date_- Descending": result.sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0)); break;
      case "size": result.sort((a, b) => (parseFloat(a.file_size) || 0) - (parseFloat(b.file_size) || 0)); break;
      case "type": result.sort((a, b) => (a.file_type || "").split("/").pop().localeCompare((b.file_type || "").split("/").pop())); break;
      case "starred_files": result.sort((a, b) => ((b.star?.length || 0) - (a.star?.length || 0))); break;
      default: result.sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0));
    }
    return result;
  })();

  const onAddFile = (e) => {
    e.stopPropagation();
    dispatch(setPopup({ key: 'upload_popup', value: true }))
  }

  const currentSortLabel = SORT_OPTIONS.find(o => o.key === sortKey)?.label || "Sort";
  const starredCount = files.filter(f => f.star?.length > 0).length;

  // ── Empty state ───────────────────────────────────────────
  // if (!files || files.length === 0) return (
  //   <div className="flex flex-col items-center justify-center py-14 px-6 text-center">
  //     <div className="w-16 h-16 bg-violet-50 rounded-3xl flex items-center justify-center mb-4">
  //       <svg className="w-8 h-8 text-violet-300" fill="none" viewBox="0 0 24 24">
  //         <path d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
  //           stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  //       </svg>
  //     </div>
  //     <p className="text-sm font-bold text-slate-700 mb-1">No files yet</p>
  //     <p className="text-xs text-slate-400 mb-5">Attach files to keep everything in one place</p>
  //     <button onClick={onAddFile}
  //       className="flex items-center gap-2 bg-violet-600 hover:bg-violet-700 text-white text-xs font-semibold px-4 py-2.5 rounded-xl transition-colors">
  //       <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24">
  //         <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
  //       </svg>
  //       Add file
  //     </button>
  //   </div>
  // );


  return (
    (!files || files.length === 0) ?
      <div className="flex flex-col items-center justify-center py-14 px-6 text-center">
        <div className="w-16 h-16 bg-violet-50 rounded-3xl flex items-center justify-center mb-4">
          <svg className="w-8 h-8 text-violet-300" fill="none" viewBox="0 0 24 24">
            <path d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
              stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </div>
        <p className="text-sm font-bold text-slate-700 mb-1">No files yet</p>
        <p className="text-xs text-slate-400 mb-5">Attach files to keep everything in one place</p>
        <button onClick={onAddFile}
          className="flex items-center gap-2 bg-violet-600 hover:bg-violet-700 text-white text-xs font-semibold px-4 py-2.5 rounded-xl transition-colors">
          <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24">
            <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
          </svg>
          Add file
        </button>
      </div>
      :
      <div className="flex flex-col">
        <style>{`@keyframes fadeSlideIn{from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:translateY(0)}}`}</style>

        {/* ── Toolbar ── */}
        <div className="px-0 pt-4 pb-3 space-y-3">

          {/* Stats row */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <span className="text-xs font-bold text-slate-700">{files.length} file{files.length !== 1 ? "s" : ""}</span>
              {starredCount > 0 && (
                <span className="flex items-center gap-1 text-xs text-amber-500 font-medium">
                  <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  </svg>
                  {starredCount} starred
                </span>
              )}
            </div>
            {/* View mode toggle */}
            <div className="flex items-center gap-1 bg-slate-100 rounded-lg p-0.5">
              {["list", "grid"].map(mode => (
                <button key={mode} onClick={() => setViewMode(mode)}
                  className={`w-7 h-7 rounded-md flex items-center justify-center transition-all
                  ${viewMode === mode ? "bg-white shadow-sm text-violet-600" : "text-slate-400"}`}>
                  {mode === "list"
                    ? <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24"><path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" /></svg>
                    : <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="2" /><rect x="14" y="3" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="2" /><rect x="3" y="14" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="2" /><rect x="14" y="14" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="2" /></svg>
                  }
                </button>
              ))}
            </div>
          </div>

          {/* Search + Sort row */}
          <div className="flex gap-2">
            {/* Search */}
            <div className="relative flex-1">
              <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-slate-400" fill="none" viewBox="0 0 24 24">
                <path d="M21 21l-4.35-4.35M17 11A6 6 0 115 11a6 6 0 0112 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
              <input value={search} onChange={e => setSearch(e.target.value)}
                placeholder="Search files…"
                className="w-full bg-slate-50 border border-slate-200 rounded-xl pl-9 pr-8 py-2 text-xs text-slate-700 focus:outline-none focus:border-violet-400 focus:bg-white transition-all placeholder-slate-300" />
              {search && (
                <button onClick={() => setSearch("")}
                  className="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 rounded-full bg-slate-200 flex items-center justify-center hover:bg-slate-300 transition-colors">
                  <svg className="w-2.5 h-2.5 text-slate-500" fill="none" viewBox="0 0 24 24">
                    <path d="M6 18L18 6M6 6l12 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                  </svg>
                </button>
              )}
            </div>

            {/* Sort dropdown */}
            <div className="relative">
              <button onClick={() => setShowSortMenu(!showSortMenu)}
                className={`flex items-center gap-1.5 px-3 py-2 rounded-xl border text-xs font-semibold transition-all
                ${showSortMenu ? "bg-violet-600 text-white border-violet-600" : "bg-slate-50 text-slate-600 border-slate-200 hover:border-violet-300"}`}>
                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24">
                  <path d="M3 6h18M7 12h10M11 18h2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
                <span className="hidden xs:inline">{currentSortLabel}</span>
              </button>

              {showSortMenu && (
                <div className="absolute right-0 top-full mt-1.5 bg-white rounded-2xl shadow-xl border border-slate-100 overflow-hidden z-30 w-44"
                  style={{ animation: "fadeSlideIn 0.15s ease forwards" }}>
                  {SORT_OPTIONS.map(opt => (
                    <button key={opt.key} onClick={() => { setSortKey(opt.key); setShowSortMenu(false); }}
                      className={`w-full flex items-center justify-between px-4 py-2.5 text-xs font-medium transition-colors
                      ${sortKey === opt.key ? "bg-violet-50 text-violet-700" : "text-slate-600 hover:bg-slate-50"}`}>
                      {opt.label}
                      {sortKey === opt.key && (
                        <svg className="w-3.5 h-3.5 text-violet-500" fill="none" viewBox="0 0 24 24">
                          <path d="M5 13l4 4L19 7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                        </svg>
                      )}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* ── Active sort chip ── */}
        {sortKey !== "date_- Descending" && (
          <div className="px-4 pb-2 flex items-center gap-2">
            <span className="text-xs text-slate-400">Sorted by</span>
            <div className="flex items-center gap-1.5 bg-violet-50 border border-violet-200 rounded-full pl-2.5 pr-1.5 py-0.5">
              <span className="text-xs font-semibold text-violet-700">{currentSortLabel}</span>
              <button onClick={() => setSortKey("date_- Descending")}
                className="w-3.5 h-3.5 rounded-full bg-violet-200 hover:bg-violet-300 flex items-center justify-center transition-colors">
                <svg className="w-2 h-2 text-violet-600" fill="none" viewBox="0 0 24 24">
                  <path d="M6 18L18 6M6 6l12 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                </svg>
              </button>
            </div>
          </div>
        )}

        {/* ── File list / grid ── */}
        <div className={`px-0 pb-4 ${viewMode === "grid" ? "grid grid-cols-2 gap-2" : "space-y-2"}`}>
          {filteredFiles.length > 0 ? filteredFiles.map(file => {
            const isImg = file.file_category === "image";
            const isVideo = (file.file_type || "").includes("video");
            const isStarred = file.star?.length > 0;
            const tags = (file.tag_list_details || []).filter((t, i, a) => a.findIndex(x => x.tag_id === t.tag_id) === i);

            // ── Grid card ──
            if (viewMode === "grid") return (
              <div key={file.id} className="bg-slate-50 border border-slate-100 rounded-2xl overflow-hidden flex flex-col">
                {/* Thumbnail */}
                <div className="w-full h-24 bg-slate-100 relative" onClick={(e) => viewFile(e, file)}>
                  {(isImg || isVideo) ? (
                    <img src={file.location} alt={file.originalname} className="w-full h-full object-cover"
                      onError={e => { e.target.style.display = "none" }} />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center">
                      <FileIcon fileType={file.file_type} fileCategory={file.file_category} />
                    </div>
                  )}
                  {/* Star overlay */}
                  <button onClick={() => toggleStar(file.id)}
                    className="absolute top-1.5 right-1.5 w-6 h-6 rounded-full bg-white flex items-center justify-center shadow-sm">
                    <svg className={`w-3 h-3 ${isStarred ? "text-amber-400 fill-amber-400" : "text-slate-400"}`} fill="none" viewBox="0 0 24 24">
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" stroke="currentColor" strokeWidth="2" />
                    </svg>
                  </button>
                </div>
                <div className="p-2.5">
                  <p className="text-xs font-semibold text-slate-700 truncate" onClick={(e) => viewFile(e, file)}>{file.originalname}</p>
                  <p className="text-xs text-slate-400 mt-0.5" onClick={(e) => viewFile(e, file)}>{niceBytes(file.file_size)}</p>
                  {tags.length > 0 && (
                    <div className="flex flex-wrap gap-1 mt-1.5">
                      {tags.slice(0, 2).map(tag => (
                        <span key={tag.tag_id} className="text-xs px-1.5 py-0 rounded-full text-white" style={{ backgroundColor: tag.tag_color }}>{tag.title}</span>
                      ))}
                      {tags.length > 2 && <span className="text-xs text-slate-400">+{tags.length - 2}</span>}
                    </div>
                  )}
                </div>
              </div>
            );

            // ── List row ──
            return (
              <div key={file.id} className="bg-slate-50 border border-slate-100 rounded-2xl overflow-hidden">
                {/* Image banner */}
                {isImg && (
                  <div className="w-full h-28 bg-slate-100" onClick={(e) => viewFile(e, file)}>
                    <img src={file.location} alt={file.originalname} className="w-full h-full object-cover"
                      onError={e => { e.target.style.display = "none" }} />
                  </div>
                )}
                <div className="p-3" onClick={(e) => viewFile(e, file)}>
                  <div className="flex items-center gap-3">
                    {!isImg && <FileIcon fileType={file.file_type} fileCategory={file.file_category} />}

                    <div className="flex-1 min-w-0">
                      <div className="flex items-start justify-between gap-2">
                        <p className="text-xs font-bold text-slate-700 truncate leading-snug">{file.originalname}</p>
                        {/* Star button */}
                        <button onClick={() => toggleStar(file.id)} className="shrink-0 mt-0.5">
                          <svg className={`w-3.5 h-3.5 transition-colors ${isStarred ? "text-amber-400 fill-amber-400" : "text-slate-300 hover:text-amber-300"}`} fill="none" viewBox="0 0 24 24">
                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" stroke="currentColor" strokeWidth="1.8" />
                          </svg>
                        </button>
                      </div>
                      <div className="flex items-center gap-2 mt-0.5">
                        <span className="text-xs text-slate-400">{niceBytes(file.file_size)}</span>
                        <span className="text-slate-200">·</span>
                        <span className="text-xs text-slate-400">
                          {new Date(file.created_at).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
                        </span>
                      </div>
                    </div>

                    {/* Download */}
                    <a href={file.location} target="_blank" rel="noreferrer"
                      className="w-8 h-8 rounded-xl bg-white border border-slate-200 flex items-center justify-center text-slate-400 hover:text-violet-600 hover:border-violet-300 transition-all shrink-0">
                      <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24">
                        <path d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                      </svg>
                    </a>
                  </div>

                  {/* Tags */}
                  <FileTags tags={tags} />
                </div>
              </div>
            );
          }) : (
            /* No search results */
            <div className="col-span-2 flex flex-col items-center py-10 text-center">
              <div className="w-12 h-12 bg-slate-100 rounded-2xl flex items-center justify-center mb-3">
                <svg className="w-6 h-6 text-slate-300" fill="none" viewBox="0 0 24 24">
                  <path d="M21 21l-4.35-4.35M17 11A6 6 0 115 11a6 6 0 0112 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </div>
              <p className="text-sm font-semibold text-slate-500">No files found</p>
              <p className="text-xs text-slate-400 mt-1">Try a different search term</p>
              <button onClick={() => setSearch("")} className="mt-3 text-xs text-violet-600 font-semibold hover:underline">Clear search</button>
            </div>
          )}
        </div>

        {/* ── Add file footer ── */}
        <div className="px-0 py-3 border-t border-slate-100">
          <button onClick={onAddFile}
            className="w-full flex items-center justify-center gap-2 py-2.5 rounded-xl border-2 border-dashed border-slate-200 hover:border-violet-400 hover:bg-violet-50 text-slate-400 hover:text-violet-600 text-xs font-semibold transition-all">
            <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24">
              <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
            </svg>
            Add file(s)
          </button>
        </div>
      </div>
  );
};

const FileTags = ({ tags }) => {
  const [showAll, setShowAll] = useState(false);
  if (!tags || tags.length === 0) return null;
  const unique = tags.filter((t, i, a) => a.findIndex(x => x.tag_id === t.tag_id) === i);
  const visible = unique.slice(0, 2);
  const extra = unique.slice(2);

  return (
    <div className="flex flex-wrap gap-1.5 mt-2.5 items-center relative">
      {visible.map(tag => (
        <span key={tag.tag_id}
          className="text-xs font-medium px-2.5 py-0.5 rounded-full text-white"
          style={{ backgroundColor: tag.tag_color }}>
          {tag.title}
        </span>
      ))}
      {extra.length > 0 && (
        <button
          onClick={e => { e.stopPropagation(); setShowAll(!showAll); }}
          className="text-xs font-semibold px-2.5 py-0.5 rounded-full bg-violet-100 text-violet-600 hover:bg-violet-200 transition-colors">
          +{extra.length}
        </button>
      )}
      {/* All-tags popup */}
      {showAll && (
        <div className="absolute bottom-full left-0 mb-2 bg-white rounded-2xl shadow-xl border border-slate-100 p-3 z-30 w-56"
          style={{ animation: "fadeSlideIn 0.15s ease forwards" }}>
          <div className="flex items-center justify-between mb-2">
            <p className="text-xs font-semibold text-slate-600">All tags</p>
            <button onClick={e => { e.stopPropagation(); setShowAll(false) }}
              className="w-5 h-5 rounded-full bg-slate-100 flex items-center justify-center hover:bg-slate-200">
              <svg className="w-3 h-3 text-slate-500" fill="none" viewBox="0 0 24 24">
                <path d="M6 18L18 6M6 6l12 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
              </svg>
            </button>
          </div>
          <div className="flex flex-wrap gap-1.5">
            {unique.map(tag => (
              <span key={tag.tag_id}
                className="text-xs font-medium px-2.5 py-0.5 rounded-full text-white"
                style={{ backgroundColor: tag.tag_color }}>
                {tag.title}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const FileIcon = ({ fileType, fileCategory }) => {
  const isImg = fileCategory === "image";
  const isAudio = fileCategory === "voice" || (fileType || "").includes("audio");
  const isVideo = (fileType || "").includes("video");
  const isPdf = (fileType || "").includes("pdf");

  const configs = {
    img: { bg: "bg-violet-100", color: "text-violet-500" },
    audio: { bg: "bg-emerald-100", color: "text-emerald-500" },
    video: { bg: "bg-rose-100", color: "text-rose-500" },
    pdf: { bg: "bg-orange-100", color: "text-orange-500" },
    other: { bg: "bg-slate-100", color: "text-slate-400" },
  };
  const cfg = isImg ? configs.img : isAudio ? configs.audio : isVideo ? configs.video : isPdf ? configs.pdf : configs.other;

  return (
    <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${cfg.bg}`}>
      <svg className={`w-5 h-5 ${cfg.color}`} fill="none" viewBox="0 0 24 24">
        {isImg
          ? <path d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          : isAudio
            ? <path d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            : isVideo
              ? <path d="M15 10l4.553-2.069A1 1 0 0121 8.82v6.36a1 1 0 01-1.447.894L15 14M4 8h8a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4a2 2 0 012-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              : isPdf
                ? <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                : <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        }
      </svg>
    </div>
  );
};

export default FilesSection;